import { render, staticRenderFns } from "./UsersNotificationsEdit.vue?vue&type=template&id=471ebe04&scoped=true"
import script from "./UsersNotificationsEdit.vue?vue&type=script&lang=js"
export * from "./UsersNotificationsEdit.vue?vue&type=script&lang=js"
import style0 from "./UsersNotificationsEdit.vue?vue&type=style&index=0&id=471ebe04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "471ebe04",
  null
  
)

export default component.exports